import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Switch as MuiSwitch } from '@mui/material'
import { darkTheme, lightTheme } from '../theme'
import { styled } from '@mui/material/styles'

const OneUISwitch = styled(MuiSwitch)(({ theme }) => ({
  width: 61,
  height: 42.5,
  '& .MuiSwitch-switchBase': {
    width: 42,
    height: 42,
    boxShadow: 'none',
    outline: '1px solid #8c8c8c',
    outlineOffset: -11,
    padding: 10,
    '&.Mui-checked': {
      outline: '1px solid #0381FE',
      color: '#FCFCFC',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#0381FE'
      }
    }
  },
  '& .MuiSwitch-track': {
    borderRadius: 42.5,
    '&.Mui-checked': {
      opacity: 1
    }
  }
}))

export default function Switch(props) {
  const onChange = (event) => {
    if (props.onChange !== undefined) {
      props.onChange(event)
    }
  }
  const darkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })

  let theme
  if (darkMode) {
    theme = createTheme(darkTheme())
  } else {
    theme = createTheme(lightTheme())
  }

  let disabled = false
  if (props.disabled !== undefined) {
    disabled = true
  }

  let defaultChecked = false
  if (props.defaultChecked !== undefined) {
    defaultChecked = true
  }

  return (
    <ThemeProvider theme={theme}>
      <OneUISwitch onChange={onChange} disabled={disabled} defaultChecked={defaultChecked} />
    </ThemeProvider>
  )
}
